import { type NotFoundRouteProps } from "@tanstack/react-router";
import { Button } from "../generic/Button";
import { ErrorPage } from "./ErrorPage";

type CustomNotFoundProps = {
  data?: { data?: Record<string, string> };
} & NotFoundRouteProps;

export function NotFound({ data }: CustomNotFoundProps) {
  return (
    <ErrorPage
      icon="file-x"
      title="Hov! Du er vist faret vild"
      message={`Beklager, ${
        data?.data?.resource ?? "siden"
      } du leder efter findes ikke.`}
      actions={
        <Button intent="primary" link={{ to: "/", replace: true }}>
          Gå tilbage til startsiden
        </Button>
      }
    />
  );
}
